import * as Yup from 'yup';

export const NewRowManuelSchema = Yup.object().shape({
  color: Yup.string().required('Etiket rengi zorunludur'),
  labelNo: Yup.number()
    .required('Etiket numarası zorunludur')
    .min(0, 'Etiket numarası 0 veya daha büyük olmalıdır'),
});
